import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";
import "./Style.css";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import Form from "react-bootstrap/Form";

export default function SimpleCode({
  show,
  closeModal,
  refreshPage,
  currentSimpleCode,
  onDeleteSuccess,
}) {
  const [data, setData] = useState({
    category_name: "",
    simpleCodes: [], // Changed to hold simple codes instead of subcategories
  });

  const [showEditModal, setShowEditModal] = useState(false);
  const [editingSimpleCode, setEditingSimpleCode] = useState(null);
  const [editForm, setEditForm] = useState({
    code: '',
    description1: '',
    description2: '',
    status: '',
  });

  // Initialize the modal with currentSimpleCode data
  useEffect(() => {
    if (currentSimpleCode) {
      setData({
        category_name: currentSimpleCode?.name || "",
        simpleCodes: currentSimpleCode?.simple_codes || [], // Fetching simple codes
      });
    }
  }, [currentSimpleCode]);

  // Handle edit modal visibility
  const handleShowEditModal = (simpleCode) => {
    setEditingSimpleCode(simpleCode);
    setEditForm({
      code: simpleCode.simple_code,
      description1: simpleCode.description1,
      description2: simpleCode.description2,
    });
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => setShowEditModal(false);

  const handleDelete = async (id) => {
    try {
      await axiosInstance.delete(`/user/simple_code/delete/${id}`);
      toast.success("Simple code deleted successfully!");

      // Update data state directly to reflect deletion in the table
      setData((prevState) => ({
        ...prevState,
        simpleCodes: prevState.simpleCodes.filter((sc) => sc.id !== id),
      }));

      refreshPage();
    } catch (error) {
      console.error("Error deleting simple code:", error);
      toast.error("Failed to delete simple code.");
    }
  };

  const handleSaveChanges = async () => {
    try {
      // Prepare the updated simple code data
      const updatedSimpleCode = {
        group_id: editingSimpleCode.group_id, // Get group_id from the current editing simple code
        code: editForm.code, // Assume you have code in editForm
        description1: editForm.description1, // First description
        description2: editForm.description2, // Second description
      };

      // Send the update request to the backend
      await axiosInstance.put(`/user/simple_code/update/${editingSimpleCode.id}`, updatedSimpleCode);
      toast.success("Simple code updated successfully!");

      // Update data state with the updated simple code
      setData((prevState) => ({
        ...prevState,
        simpleCodes: prevState.simpleCodes.map((sc) =>
          sc.id === editingSimpleCode.id ? { ...sc, ...updatedSimpleCode } : sc
        ),
      }));
      setShowEditModal(false);
    } catch (error) {
      console.error("Error updating simple code:", error);
      toast.error("Failed to update simple code.");
    }
  };



  return (
    <div className="CreateCSP">
      <Modal show={show} onHide={closeModal} dialogClassName="modal-md">
        <Modal.Header closeButton>
          <Modal.Title>
            <h5>
              Simple Codes for{" "}
              <span>{data?.category_name}</span>
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive table-card mt-2 mb-2 border border-dashed ">
            <table
              className="table align-middle table-nowrap table table-striped table-borderless table-hover"
              id="simpleCodeTable"
            >
              <thead className="table-light text-muted">
                <tr>
                  <th scope="col">#</th>
                  <th>Code</th>
                  <th>Description 1</th>
                  <th>Description 2</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody className="list form-check-all">
                {data.simpleCodes.map((sc, idx) => (
                  <tr key={idx}>
                    <td scope="row">{idx + 1}</td>
                    <td>{sc.simple_code}</td>
                    <td>{sc.description1}</td>
                    <td>{sc.description2}</td>
                    
                    <td>
                      <div className="dropdown">
                        <button
                          className="btn btn-icon btn-sm fs-16 text-muted dropdown"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="mdi mdi-apps"></i>
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <Link
                              className="dropdown-item"
                              onClick={() => handleShowEditModal(sc)}
                            >
                              <i className="mdi mdi-pencil me-2 text-success"></i>{" "}
                              Edit
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              onClick={() => handleDelete(sc.id)}
                            >
                              <i className="mdi mdi-trash-can-outline me-2 text-danger"></i>
                              Delete
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={handleCloseEditModal} dialogClassName="modal-md">
        <Modal.Header closeButton>
          <Modal.Title>Edit Simple Code</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <h6>Code</h6>
            <Form.Control
              type="text"
              placeholder="Enter code"
              name="code"
              value={editForm.code}
              onChange={(event) => setEditForm({ ...editForm, code: event.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <h6>Description 1</h6>
            <Form.Control
              type="text"
              placeholder="Enter description 1"
              name="description1"
              value={editForm.description1}
              onChange={(event) => setEditForm({ ...editForm, description1: event.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <h6>Description 2</h6>
            <Form.Control
              type="text"
              placeholder="Enter description 2"
              name="description2"
              value={editForm.description2}
              onChange={(event) => setEditForm({ ...editForm, description2: event.target.value })}
            />
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEditModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSaveChanges}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
